import { Image } from "react-bootstrap";
import styled from "styled-components";

export const PersonalCard = styled.section`
  background-color: var(--gray-800);
  margin-top: 4rem;

  border-radius: 8px;
  overflow: hidden;

  @media (min-width: 1024px) {
    position: fixed;
    z-index: 999;
  }

  strong {
    font-size: 1.5rem;
  }
`;

export const ContentCard = styled.div`
  background-color: var(--color-purple);
  width: 100%;
`;

export const Cover = styled.div`
  background-size: cover;
  background-position: center center;
  width: calc(10rem + 12px);
  height: calc(10rem + 12px);
  border-radius: 1000px;
  border: 4px solid var(--gray-800);
  outline: 3px solid var(--color-purple);
`;

export const Title = styled.h1`
  font-weight: 900;
`;

export const SubTitle = styled.h2`
  font-size: 1.5rem;
`;

export const Span = styled.p`
  color: var(--color-light);
  font-weight: bold;
`;

export const Alignment = styled.div`
  color: red;
`;

export const LayoutCoverImage = styled(Image)`
  width: 100%;
  height: 8rem;
  object-fit: cover;
`;

export const Profile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: calc(-1.5rem - 6px);
`;
